import { forceAppID } from "./force-id";
import { isPlayer } from "../routes";
import { getLocationSettingsUnsafe, LocationSettings, Location } from "common/location-common";
import { getFeatureFlag } from "common/feature-flags";
import { getFeatureSetting } from "common/feature-settings";

function getLocation(): Location {
    const { glideEnv } = window as any;
    if (forceAppID !== undefined || glideEnv === "prod" || getFeatureFlag("useProductionDatabase")) {
        return "production";
    }
    if (glideEnv === "staging") return "staging";
    if (glideEnv === "sandbox") return "sandbox";
    return "dev";
}

export function getLocationSettings(): LocationSettings {
    const location = getLocation();
    const player = isPlayer();
    let settings = getLocationSettingsUnsafe(location, player);

    if ((window as any).overrideCloudFunctionLocation !== undefined) {
        settings = {
            ...settings,
            cloudURLPrefix: (window as any).overrideCloudFunctionLocation,
        };
    }

    if (location === "dev" && window.location.hostname !== "localhost") {
        // If we're on a development platform but aren't exactly on "localhost",
        // we need to redirect through staging proper to make Sign in with Google
        // function correctly.
        const stagingSettings = getLocationSettingsUnsafe("staging", player);
        settings = {
            ...settings,
            oAuthCallbackURL: stagingSettings.oAuthCallbackURL,
        };
    }

    let shouldUseContainerForSignInWithGoogle = getFeatureFlag("usePlayerSmallContainer") !== false;
    if (!settings.isDevelopment) {
        shouldUseContainerForSignInWithGoogle ||= getFeatureSetting("usePlayerSmallContainer") !== false;
    }

    if (shouldUseContainerForSignInWithGoogle) {
        // If we're using the playerSmall container, we likely want to be
        // sending all our signInWith through said container.
        const origCallbackURLObj = new URL(settings.oAuthCallbackURL);
        const containerPrefixURLObj = new URL(settings.playerSmallContainerURLPrefix);
        let prefixPathname = containerPrefixURLObj.pathname;
        while (prefixPathname.endsWith("/")) {
            prefixPathname = prefixPathname.substring(0, prefixPathname.length - 1);
        }
        origCallbackURLObj.host = containerPrefixURLObj.host;
        origCallbackURLObj.pathname = prefixPathname + origCallbackURLObj.pathname;
        settings = {
            ...settings,
            oAuthCallbackURL: origCallbackURLObj.href,
        };
    }

    return settings;
}
